
import { createStore } from 'vuex'

import modules from './entities'

export const store = createStore(modules)
